import React from "react";

const ScepterIcon = () => {
	return (
		<svg viewBox="74.82 130.19 384.43 275.49">
						<path
							d="     M336.311,263.929c4.964,3.606,10.669,8.511,16.705,10.039c2.021,0.51,13.734,2.427,14.927,2.03     c13.147-4.362-17.954-32.058-20.404-34.38c-46.517-44.092-97.883-90.177-162.503-103.75     c-30.717-6.451-73.046-13.219-102.315,2.255c-2.77,1.465-4.54,4.526-7.401,6.099c17.388,0.274,32.577,4.777,49.173,9.896     c17.203,5.305,33.732,12.761,48.894,22.494c9.022,5.792,14.093,11.116,24.245,8.812c7.684-1.737,19.26-3.968,18.975,8.84     c10.658-10.126,28.998,4.205,38.333,10.03c17.158,10.708,33.119,21.274,49.127,33.583     C314.697,248.05,325.465,256.046,336.311,263.929z"
							fill="currentColor"
							stroke='transparent'
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeWidth="13.3261"
						/>
						<path
							d="     M265.354,230.339c0.227,1.625,0.252,3.251,0.036,4.829c-1.335,9.711-12.777,13.254-21.074,14.971     c-9.286,1.922-25.286-7.723-29.899-15.326c-4.428-7.303-5.405-19.002-0.249-26.286c8.738-12.34,31.797-2.564,41.181,4.737     C260.18,217.021,264.432,223.712,265.354,230.339z"
							fill="currentColor"
							stroke='transparent'
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeWidth="13.3261"
						/>
						<path
							d="     M219.779,241.272c-6.97-2.145-14.777-2.758-21.156-6.53c-8.021-4.739-5.886-9.752-10.695-15.973     c-5.977-7.731-16.978-4.749-24.736-8.724c-7.122-3.656-14.696-13.209-16.494-21.002c-7.977,22.755,22.337,48.453,37.397,61.396     c15.61,13.419,31.174,17.906,50.648,19.371c14.35,1.083,24.113,9.237,28.417,23.762c1.902,6.42,0.855,13.778,5.681,19.216     c6.119,6.898,15.757,5.617,23.628,5.396c29.849-0.851,54.589,9.505,78.766,25.798c19.063,12.85,31.64,31.87,48.774,46.306     c-6.73-16.295-11.528-29.358-23.435-42.946c-15.633-17.847-33.773-33.482-52.707-47.189c-6.378-4.615-12.456-9.171-18.344-14.805     c-5.031-4.808-11.3-11.743-17.944-13.569c-5.291-1.464-11.677,0.691-17.146,0.617c-7.327-0.098-15.05-1.229-22.104-2.75     c-9.186-1.979-17.569-6.305-24.849-11.556C234.745,251.788,230.64,244.61,219.779,241.272z"
							fill="currentColor"
							stroke='transparent'
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeWidth="13.3261"
						/>
						<path
							d="     M219.779,241.272c-6.97-2.145-14.777-2.758-21.156-6.53c-8.021-4.739-5.886-9.752-10.695-15.973     c-5.977-7.731-16.978-4.749-24.736-8.724c-7.122-3.656-14.696-13.209-16.494-21.002c-7.977,22.755,22.337,48.453,37.397,61.396     c15.61,13.419,31.174,17.906,50.648,19.371c14.35,1.083,24.113,9.237,28.417,23.762c1.902,6.42,0.855,13.778,5.681,19.216     c6.119,6.898,15.757,5.617,23.628,5.396c29.849-0.851,54.589,9.505,78.766,25.798c19.063,12.85,31.64,31.87,48.774,46.306     c-6.73-16.295-11.528-29.358-23.435-42.946c-15.633-17.847-33.773-33.482-52.707-47.189c-6.378-4.615-12.456-9.171-18.344-14.805     c-5.031-4.808-11.3-11.743-17.944-13.569c-5.291-1.464-11.677,0.691-17.146,0.617c-7.327-0.098-15.05-1.229-22.104-2.75     c-9.186-1.979-17.569-6.305-24.849-11.556C234.745,251.788,230.64,244.61,219.779,241.272z"
							fill="currentColor"
							stroke='transparent'
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeWidth="13.3261"
						/>
						<path
							d="     M435.119,405.18c-8.554-0.871-16.632-24.479-19.271-30.329c-6.75-14.967-15.965-26.289-28.445-37.026     c-13.406-11.542-25.542-21.566-40.176-31.171c-7.317-4.803-14.346-9.947-21.62-14.937c-4.236-2.917-8.999-5.99-13.27-8.558     c-6.252-3.792-13.958,0.528-10.498-9.207c1.359-3.819,1.544-7.721,1.374-11.824c-0.37-9-3.505-17.223-7.453-25.224     c-2.31-4.676-5.502-8.593-2.667-13.878c4.581-8.545,13.908-2.776,20.149,0.435c44.143,22.71,72.316,68.222,107.832,101.922     c12.987,12.325,25.828,24.445,37.672,37.484"
							fill="currentColor"
							stroke='transparent'
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeWidth="13.3261"
						/>
						<path
							d="     M423.665,392.659c-3.609-6.944-6.446-14.771-7.817-17.809c-6.75-14.967-15.965-26.289-28.445-37.026     c-13.406-11.542-25.542-21.566-40.176-31.171c-7.317-4.803-14.346-9.947-21.62-14.937c-4.188-2.879-8.538-6.26-13.123-8.472     c-2.302-1.109-6.627-1.111-8.371-2.546c-4.725-3.876-0.651-14.293-0.935-19.36c-0.488-8.704-3.596-16.693-7.42-24.436     c-2.311-4.675-5.5-8.592-2.665-13.877c4.581-8.545,13.908-2.776,20.149,0.435c44.143,22.71,72.316,68.222,107.832,101.922     c10.012,9.501,19.936,18.88,29.383,28.652"
							fill="currentColor"
							stroke='transparent'
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeWidth="13.3261"
						/>
						<path
							d="     M327.107,231.027c6.375,18.42,13.39,40.97,5.106,58.896"
							fill="currentColor"
							stroke='transparent'
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeWidth="13.3261"
						/>
						<path
							d="     M361.111,263.631c4,18.053,4.313,31.071-3.838,46.662"
							fill="currentColor"
							stroke='transparent'
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeWidth="13.3261"
						/>
						<path
							d="     M395.685,302.62c3.407,11.226,10.449,29.737,4.786,41.18"
							fill="currentColor"
							stroke='transparent'
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeWidth="13.3261"
						/>
		</svg>
	);
};

export default ScepterIcon;
